import React, { useEffect, useState } from "react";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Button, Col, Row } from "reactstrap";

// NOTE: This is a dedicated print/PDF page for the Employee Loan Register
// Report only. It intentionally does NOT reuse /PrintReportsNew (which is
// shared by other reports and expects a flat row list) so that this
// report's per-employee grouped layout can't affect any other report.
// It reads its own localStorage key ("loanRegisterReportState") rather
// than the shared "reportState" key for the same reason.

var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
var customerName = localStorage.getItem("firstName");
var loginId = localStorage.getItem("username");
let currentDate = moment(new Date()).format("YYYY-MM-DD");
if (loginId === "SJM_Admin@gmail.com") {
  customerName = loginId.toString().replace(":", "").split("@")[0];
}

export default function EmpLoanRegisterReportPrint(props) {
  const reportState = JSON.parse(
    localStorage.getItem("loanRegisterReportState") || "{}",
  );

  const [data] = useState({
    dynamicInvMessage:
      reportState?.dynamicInvMessage || "Employee Loan Register Report",
    reportName: reportState?.reportName || "Employee_Loan_Register_Report",
    companyName:
      reportState?.companyName || localStorage.getItem("companyName") || "",
    criteriaString: reportState?.criteriaString || "All",
    goBackUrl: reportState?.goBackUrl || "/empLoanRegisterReport",
    groupedData: reportState?.groupedData || [],
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      props.history.push({ pathname: "/login" });
      return;
    }
    if (!reportState.groupedData) {
      props.history.push({ pathname: data.goBackUrl });
    }
    // localStorage.removeItem("loanRegisterReportState");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goBackFun = () => {
    props.history.push({ pathname: data.goBackUrl });
  };

  const isTotalRow = (row) =>
    row.description === "Sub Total" || row.description === "Grand Total";

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 10;
    let cursorY = 15;

    doc.setFontSize(16);
    doc.text(data.dynamicInvMessage, marginLeft, cursorY);
    cursorY += 7;
    doc.setFontSize(10);
    doc.text(`Data Criteria: ${data.criteriaString}`, marginLeft, cursorY);
    cursorY += 8;

    (data.groupedData || []).forEach((group) => {
      // Keep each employee's header line attached to its table; start a
      // fresh page if there isn't enough room left.
      if (cursorY > pageHeight - 40) {
        doc.addPage();
        cursorY = 15;
      }

      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      doc.text(
        `Emp Code: ${group.emp_code || ""}    Designation: ${
          group.designation || ""
        }    Shift: ${group.shift || ""}`,
        marginLeft,
        cursorY,
      );
      cursorY += 5;
      doc.text(
        `Emp Name: ${group.emp_name || ""}    Department: ${
          group.department || ""
        }`,
        marginLeft,
        cursorY,
      );
      doc.setFont(undefined, "normal");
      cursorY += 3;

      const body = (group.rows || []).map((row) => {
        const total = isTotalRow(row);
        return [
          row.txn_date || "",
          total ? "" : row.loan_type_desc || "",
          total ? "" : row.doc_no || "",
          row.description || "",
          row.debit,
          row.credit,
          row.balance,
        ];
      });

      doc.autoTable({
        head: [
          ["Date", "Loan Type", "Doc No", "Description", "Debit", "Credit", "Balance"],
        ],
        body,
        startY: cursorY,
        margin: { left: marginLeft, right: marginLeft },
        theme: "striped",
        styles: { fontSize: 8, cellPadding: 1.5 },
        headStyles: { fillColor: [63, 14, 128] },
        columnStyles: {
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
        },
        didParseCell: (d) => {
          const desc = d.row.raw[3];
          if (desc === "Sub Total" || desc === "Grand Total") {
            d.cell.styles.fontStyle = "bold";
          }
        },
      });

      cursorY = doc.lastAutoTable.finalY + 8;
    });

    doc.save(data.reportName);
  };

  return (
    <>
      <Row id="app-body-Invoice" className="app-body-Invoice mt-3">
        <Col xs="12">
          <Row>
            <Col xs="6">
              <h2 style={{ marginLeft: "5px" }}>{data.companyName}</h2>
            </Col>
            <Col xs="4">
              <span style={{ marginLeft: "13em" }}>
                <span>Printed By </span>: (
                <span className="text-success"> {customerName} </span> )
              </span>
            </Col>
            <Col xs="2">
              <span style={{ marginLeft: "0rem" }}>
                <span>Printed Date </span>: (
                <span className="text-success"> {currentDate} </span> )
              </span>
            </Col>
            <Col xs="8">
              <h3 style={{ marginLeft: "5px" }}>{data.dynamicInvMessage}</h3>
            </Col>
            <Col xs="4">
              <div style={{ textAlign: "end" }}>
                <Button className="btn btn-warning" onClick={downloadPDF}>
                  Print PDF
                </Button>
                <button
                  className="btn btn-secondary m-1"
                  onClick={goBackFun}
                >
                  Back
                </button>
              </div>
            </Col>

            <Col xs="12">
              <p style={{ marginLeft: "5px" }}>
                <b>Data Criteria: {data.criteriaString}</b>
              </p>
            </Col>

            <Col xs="12">
              {data.groupedData.length === 0 ? (
                <p>Loading data...</p>
              ) : (
                data.groupedData.map((group, gIdx) => (
                  <div
                    key={`print-emp-group-${gIdx}`}
                    style={{ marginBottom: "24px" }}
                  >
                    <table
                      style={{
                        width: "100%",
                        marginBottom: "6px",
                        borderCollapse: "collapse",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td style={{ padding: "2px 6px" }}>
                            <strong>Emp Code:</strong> {group.emp_code}
                          </td>
                          <td style={{ padding: "2px 6px" }}>
                            <strong>Designation:</strong> {group.designation}
                          </td>
                          <td style={{ padding: "2px 6px" }}>
                            <strong>Shift:</strong> {group.shift}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: "2px 6px" }}>
                            <strong>Emp Name:</strong> {group.emp_name}
                          </td>
                          <td style={{ padding: "2px 6px" }}>
                            <strong>Department:</strong> {group.department}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>

                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ background: "#3f0e80", color: "#fff" }}>
                          <th style={{ textAlign: "left", padding: "4px 6px" }}>
                            Date
                          </th>
                          <th style={{ textAlign: "left", padding: "4px 6px" }}>
                            Loan Type
                          </th>
                          <th style={{ textAlign: "left", padding: "4px 6px" }}>
                            Doc No
                          </th>
                          <th style={{ textAlign: "left", padding: "4px 6px" }}>
                            Description
                          </th>
                          <th style={{ textAlign: "right", padding: "4px 6px" }}>
                            Debit
                          </th>
                          <th style={{ textAlign: "right", padding: "4px 6px" }}>
                            Credit
                          </th>
                          <th style={{ textAlign: "right", padding: "4px 6px" }}>
                            Balance
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {group.rows.map((row, rIdx) => {
                          const total = isTotalRow(row);
                          return (
                            <tr
                              key={`print-emp-${gIdx}-row-${rIdx}`}
                              style={
                                total ? { borderTop: "1px solid #333" } : undefined
                              }
                            >
                              <td style={{ padding: "3px 6px" }}>
                                {row.txn_date}
                              </td>
                              <td
                                style={{
                                  padding: "3px 6px",
                                  fontWeight: total ? "bold" : "normal",
                                }}
                              >
                                {total ? "" : row.loan_type_desc}
                              </td>
                              <td style={{ padding: "3px 6px" }}>
                                {total ? "" : row.doc_no}
                              </td>
                              <td
                                style={{
                                  padding: "3px 6px",
                                  fontWeight: total ? "bold" : "normal",
                                }}
                              >
                                {row.description}
                              </td>
                              <td
                                style={{
                                  padding: "3px 6px",
                                  textAlign: "right",
                                  fontWeight: total ? "bold" : "normal",
                                }}
                              >
                                {row.debit}
                              </td>
                              <td
                                style={{
                                  padding: "3px 6px",
                                  textAlign: "right",
                                  fontWeight: total ? "bold" : "normal",
                                }}
                              >
                                {row.credit}
                              </td>
                              <td
                                style={{
                                  padding: "3px 6px",
                                  textAlign: "right",
                                  fontWeight: total ? "bold" : "normal",
                                }}
                              >
                                {row.balance}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ))
              )}
            </Col>

            <Col xs="12">
              <p>
                * <span className="text-danger">Note</span>: All figures
                indicated are in the company's currency (
                <span className="text-success"> {companySymbolCurrency} </span>
                ) .
              </p>
            </Col>
          </Row>
          <br />
        </Col>
      </Row>
    </>
  );
}
